///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2020
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";
import { Link } from "react-router-dom";

import messages from "../../helpers/messages";

function NoPendingBids() {
  return (
    <div
      data-testid="no-pending-bids"
      className="flex justify-center text-center items-center full-height no-pending-bids"
    >
      <div style={{ width: "50%", maxWidth: "500px" }}>
        <p className="mb-32 title univers-65-bold color-grey weight--normal">
          {messages.youAreCaughtUp.defaultMessage}
        </p>
        <p className="mb-36 message">
          {messages.noPendingBidsMessage.defaultMessage}
        </p>
        <Link to="/">
          <button className="primary-button univers-67-bold-cond px-24">
            {messages.returnHome.defaultMessage}
          </button>
        </Link>
      </div>
    </div>
  );
}

export default NoPendingBids;
